var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPercents = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99596 5.87995C3.99596 4.83912 4.83929 3.99578 5.88013 3.99495H6.73763C7.23513 3.99495 7.71179 3.79745 8.06513 3.44745L8.66429 2.84745C9.39846 2.10912 10.5918 2.10578 11.3301 2.83995L11.331 2.84078L11.3385 2.84745L11.9385 3.44745C12.2918 3.79828 12.7685 3.99495 13.266 3.99495H14.1226C15.1635 3.99495 16.0076 4.83828 16.0076 5.87995V6.73578C16.0076 7.23328 16.2043 7.71078 16.5551 8.06412L17.1551 8.66412C17.8935 9.39828 17.8976 10.5916 17.1635 11.33L17.1626 11.3308L17.1551 11.3383L16.5551 11.9383C16.2043 12.2908 16.0076 12.7674 16.0076 13.2649V14.1225C16.0076 15.1633 15.1643 16.0066 14.1235 16.0066H14.1226H13.2643C12.7668 16.0066 12.2893 16.2041 11.9368 16.555L11.3368 17.1541C10.6035 17.8925 9.41096 17.8966 8.67263 17.1641C8.67179 17.1633 8.67096 17.1625 8.67013 17.1616L8.66263 17.1541L8.06346 16.555C7.71096 16.2041 7.23346 16.0075 6.73596 16.0066H5.88013C4.83929 16.0066 3.99596 15.1633 3.99596 14.1225V13.2633C3.99596 12.7658 3.79846 12.2891 3.44763 11.9366L2.84846 11.3366C2.11013 10.6033 2.10596 9.41078 2.8393 8.67245C2.8393 8.67162 2.84013 8.67078 2.84096 8.66995L2.84846 8.66245L3.44763 8.06245C3.79846 7.70912 3.99596 7.23245 3.99596 6.73412V5.87995",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85938 12.143L12.1427 7.85962",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0799 12.0832H12.0874",
    stroke: "#EC6A4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91292 7.91667H7.92042",
    stroke: "#EC6A4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPercents, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/percents.3ce6b2eb.svg";
export { ForwardRef as ReactComponent };